import { PreloadedState } from '@reduxjs/toolkit';

import { ReduxActions, ReduxState, ReduxStore, getReduxStore } from 'shared/store/clientSide';

import { IClientSideState } from '../IClientSideState';

export class ClientSideState implements IClientSideState {
  public static readonly key = 'clientSideState';

  public readonly store: ReduxStore;

  public constructor(preloadedState: PreloadedState<ReduxState> | undefined, devTools: boolean) {
    this.store = getReduxStore(preloadedState, devTools);
  }

  public getState(): ReduxState {
    return this.store.getState();
  }

  public dispatch(action: ReduxActions): void {
    this.store.dispatch(action);
  }
}
